import { locales } from '@alltrails/types/Locale';
import { type LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { getLocalePrefixFromLanguageRegionCode } from './languageTypeModifiers';

/**
 * Generates a new localized url for a given link and language region code.
 *
 * Example: `generateNewLanguageUrl('/es/some/path', 'it-IT')` => `/it-it/some/path`
 * @param link - The link to generate a new localized url for
 * @param newLang - The new language region code to generate a new language url for
 * @returns The new localized url
 */
export function generateNewLanguageUrl(link: string, newLang: LanguageRegionCode): string {
  if (typeof window === 'undefined' || !window.location) {
    return link;
  }

  let localePrefix = getLocalePrefixFromLanguageRegionCode(newLang);

  // getLocalePrefix returns an empty string when 'en-US'
  if (localePrefix.length !== 0) {
    localePrefix = `/${localePrefix}`;
  }

  const allPrefixes = locales.join('|');
  const containsLangFolder = new RegExp(`^(${allPrefixes})(/|$)`);
  const cleanUrl = link.substring(1).replace(containsLangFolder, '');
  const newLink = `${localePrefix}/${cleanUrl}${window.location.search}`;

  return newLink.replace(/([^:]\/)\/+/g, '$1');
}
